module.exports = __webpack_public_path__ + "static/image/bg_renzheng_yonggong@2x.png";